import productDetailsFragment from './productDetails.fragment'

const productResultPageProductsFragment = /* GraphQL */ `
  fragment productResultPageProductsFragment on ProductResultPageResponse {
    searchProducts {
      skuBaseNumber
      skuBaseName
      position
      lazyLoad
      matchedFields
      scores {
        value
        field
        order
      }
      boostingRules {
        boostName
        appliedBoostingConfiguration
        boostPositions
      }
      lazyLoadData {
        title
        url
      }
      skuBaseDetails {
        ...productDetailsFragment
      }
    }
  }
  ${productDetailsFragment}
`

export default productResultPageProductsFragment
